export default __webpack_public_path__ + "static/media/stand_2.e39327b8.jpg";